'use client';

import clsx from 'clsx';
import type { SectionCardProps } from './types';

export default function SectionCard({
    children,
    className,
    classNames = {},
    showCorner = false,
}: SectionCardProps) {
    const { root, hover, glow, corner } = classNames;
    return (
        <div className={clsx(root, className)}>
            <div className={clsx(hover)} aria-hidden />
            <div className={clsx(glow)} aria-hidden />
            {showCorner && <div className={clsx(corner)} aria-hidden />}
            {children}
        </div>
    );
}
